export default "__VITE_ASSET__OwE6iLj0__"